import React from 'react';
import styles from './basket-amount.scss';

export const BasketAmount = ({ basketItems }) => (
  <>
    <span
      data-test="basket-amount"
      data-testid="basket-amount"
      className={basketItems > 0 ? styles.icon : styles.visuallyHidden}
    >
      {basketItems}
    </span>
    <span className={styles.visuallyHidden}>items in Basket</span>
  </>
);
